import type { ServerLifecycleOperation } from '../types/server';

const TERMINAL_OPERATION_PHASES = new Set(['succeeded', 'failed_terminal']);

export function isLifecycleOperationActive(operation?: ServerLifecycleOperation | null): boolean {
  return Boolean(operation && !TERMINAL_OPERATION_PHASES.has(operation.phase));
}

export function formatSettingLabel(name: string): string {
  const withSpaces = name
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim();
  return withSpaces ? withSpaces[0].toUpperCase() + withSpaces.slice(1) : name;
}

export function formatSettingValue(value: unknown): string {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (Array.isArray(value)) return value.map(item => String(item)).join(', ');
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}
